import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
// Removed unused Layout import, enforcing styling directly

const Login = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useAuth(); 

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); 

        try {
            const res = await axios.post(
                'http://localhost:5000/api/auth/login',
                formData
            );

            const token = res.data.token;
            login(token); 
            
            // Redirect the user to the admin dashboard since this is the "Dev Access" login
            navigate('/admin'); 

        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Login failed. Check API connectivity.';
            setError(errorMessage);
        }
    };

    return (
        // 🛑 FIX: Added min-h-screen and bg-gray-950 to ensure the dark background 
        // fills the viewport regardless of where the component is rendered.
        <div className="min-h-screen flex items-center justify-center bg-gray-950 py-20 px-4"> 
            
            {/* Login Card (Dark, sharp edges, high-tech glow) */}
            <div 
                className="w-full max-w-lg bg-gray-800 p-10 lg:p-12 rounded-xl shadow-2xl transition duration-500 transform hover:shadow-teal-500/50 border border-gray-700"
            >
                {/* Title: Sans-serif, high-contrast Teal/Blue gradient */}
                <h2 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-400 text-center mb-10 tracking-wide">
                    System Access // DEV PORTAL
                </h2>
                
                <form onSubmit={handleSubmit} className="space-y-6">
                    
                    {/* Email Input */}
                    <div>
                        {/* Label: Light gray text */}
                        <label className="block text-sm font-medium text-gray-300 mb-2" htmlFor="email">Auth ID (Email or Key)</label>
                        <input
                            id="email"
                            type="email"
                            name="email"
                            placeholder="user@dev.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            // Inputs: Dark background, focus ring in teal
                            className="w-full px-4 py-3 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-teal-500 focus:border-teal-500 transition duration-150 shadow-inner"
                        />
                    </div>

                    {/* Password Input */}
                    <div>
                        {/* Label: Light gray text */}
                        <label className="block text-sm font-medium text-gray-300 mb-2" htmlFor="password">Secret Key</label>
                        <input
                            id="password"
                            type="password"
                            name="password"
                            placeholder="••••••••"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            // Inputs: Dark background, focus ring in teal
                            className="w-full px-4 py-3 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-teal-500 focus:border-teal-500 transition duration-150 shadow-inner"
                        />
                    </div>

                    {/* Submit Button */}
                    <button 
                        type="submit"
                        // Button: High-contrast Teal color, shadow glow on hover
                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-lg text-lg font-bold text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition duration-300 transform hover:scale-[1.01] mt-8 focus:ring-offset-gray-800"
                        disabled={false}
                    >
                        Authenticate Access
                    </button>
                </form>

                {/* Error Message Display */}
                {error && (
                    <p className="mt-6 text-center text-sm font-medium text-red-400 bg-red-900/50 p-3 rounded-lg border border-red-700">
                        {error}
                    </p>
                )}
                
                <p className="mt-6 text-center text-xs text-gray-500">
                    This portal is secured. Proceed with caution.
                </p>
            </div>
        </div>
    );
};

export default Login;
